<div class="d-flex justify-content-between flex-wrap align-items-center gap-4">
  <div class="btn-group subpage-nav d-flex flex-wrap" role="group">
    @for (page of pages(); track page) {
      <a [routerLink]="page.link" (click)="setActive(page)"
        class="{{ isActive(page) ? 'active' : '' }} subpage-nav-item border d-flex flex-column align-items-center">
        @if (page.icon) {
          <i class="{{ page.icon }}"></i>
        }
        <span>{{ page.value|translate }}</span>
      </a>
    }
  </div>

  <ng-content></ng-content>

</div>
